import { ReactNode } from "react";
import style from "./SectionTitle.module.scss";

export const SectionTitle = ({ children }: { children: ReactNode }) => (
  <div className={style.formTitleWrapper}>
    <span className={style.formTitle}>{children}</span>
    <hr className={style.line} />
  </div>
);
